import React from "react";
import { withFormik, Form, Field } from "formik";
import * as yup from "yup";
import ThankYouMessage from "./ThankYouMessage";
import emailLabel from "../images/headings/enterEmail.svg";

const SignUpForm = ({ errors, touched, isSubmitting, status }) => {
  return (
    <Form className="signup-form" name="subscriptionForm" method="post">
      {status == null ? (
        <FormFields
          errors={errors}
          touched={touched}
          isSubmitting={isSubmitting}
          status={status}
        />
      ) : null}
      {status != null ? <Alert status={status} /> : null}
    </Form>
  );
};

const FormFields = ({ errors, touched, isSubmitting }) => {
  return (
    <>
      <div className="form__group">
        <label htmlFor="email" className="form__label">
          <img src={emailLabel} alt="Enter email for location" />
        </label>
        <Field id="email" name="email" type="email" className="form__text" />
        {errors.email && touched.email ? (
          <p className="form__error">{errors.email}</p>
        ) : null}
      </div>
      <div className="form__group form__group--checkbox">
        <Field
          id="terms"
          name="terms"
          type="checkbox"
          className="form__checkbox"
        />
        <label className="form__label" htmlFor="terms">
          I agree to the{" "}
          <a href="https://www.thewildhoneypie.com/legal" target="_blank">
            Terms &amp; Conditions
          </a>
        </label>
      </div>
      {errors.terms && touched.terms ? (
        <p className="form__error form__error--checkbox">{errors.terms}</p>
      ) : null}
      <button
        className="button button--centre"
        type="submit"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Loading" : "Submit"}
      </button>
    </>
  );
};

const Alert = ({ status }) => {
  return status === "success" ? (
    <div className="signup-form__alert">
      <ThankYouMessage />
      <p>Look out for our email.</p>
    </div>
  ) : (
    <p>Submission error, please contact us via email.</p>
  );
};

const SignUpFormikWrapper = ({ setFormSuccess }) => {
  const SignUpFormik = withFormik({
    mapPropsToValues: () => {
      return {
        email: "",
        terms: false,
      };
    },
    validationSchema: yup.object().shape({
      email: yup
        .string()
        .email("Please enter a valid email address")
        .required("Email address is required"),
      terms: yup.boolean().oneOf([true], "Please tick to accept terms"),
    }),
    handleSubmit(values, { setStatus, setErrors }) {
      // do our post request to the PHP file on server
      const response = fetch(
        `https://www.thewildhoneypie.com/fullbloom/api/mailchimp.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ ...values }),
        }
      );
      response
        .then((res) => {
          return res.text();
        })
        .then((res) => {
          const data = JSON.parse(res);
          if (!data.success) {
            alert("Something went wrong with your entry, please try again");
            return;
          }
          // Set our state to hide form and show our Thank you msg
          setStatus("success");
        })
        .catch((error) => {
          console.log(error);
          setErrors(error);
        });
    },
  })(SignUpForm);

  return <SignUpFormik />;
};

export default SignUpFormikWrapper;
